<template>
  <div>
    <!-- Profit Loss Exp Invoice Summary Section Start -->
    <div></div>
    <b-button
      v-if="clientID > 0"
      class="mb-1 mt-1"
      @click="getJobHistory(clientID)"
      size="xs"
      style="font-size: 0.675rem"
      >Job History</b-button
    >
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="JobHistory-modal"
      hide-footer
      :title="Page_title"
    >
     <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <b-row>
        <b-col md="12">
          <b-button
            class="pull-right mb-1"
            v-if="JobHistoryList.length > 0"
            :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
            @click="getReports('getJobHistoryList', 'Export As Excel')"
            size="sm"
            variant="warning"
          >
            {{ ExcelBtnName }}
            <b-spinner
              v-if="ExcelBtnName != 'Export As Excel'"
              small
              label="Small Spinner"
            ></b-spinner
          ></b-button>
          <b-table
            show-empty
            stacked="md"
            :items="JobHistoryList"
            :fields="JobHistoryfields"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="SN" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="JOBNO" slot-scope="row1">
              <span>JOB No : {{ row1.item.JOBNO }}<br /></span>
              <span>JOB Date : {{ row1.item.JOBDate }}<br /></span>
              <span>Job Type : {{ row1.item.JOBTYPE }}<br /></span>
              <span>Shipment Type : {{ row1.item.shipmentType }}<br /></span>
              <span>Transport Type : {{ row1.item.transportType }}<br /></span>
              <span>Raised From : {{ row1.item.Branch }}<br /></span>
              <span>Raised By : {{ row1.item.RaisedBy }}<br /></span>
              <InvExpSummary
                v-if="row1.item.allModuleId"
                :PMC_title="'Inv Exp Summary Job No - ' + row1.item.JOBNO"
                :PMC_JOBID="row1.item.allModuleId"
                :PMC_JOBNO="row1.item.JOBNO"
                :PMC_JOBDATE="row1.item.JOBDate"
                :PMC_JOBTYPE="row1.item.JOBTYPE"
                :PMC_AgentType="''"
                :PMC_Client="row1.item.clientName"
                :PMC_Sline="row1.item.shippingLine"
              />
              <ContainerSummary
                v-if="row1.item.allModuleId"
                :PMC_title="'Container Summary Job No - ' + row1.item.JOBNO"
                :PMC_JOBID="row1.item.allModuleId"
                :PMC_JOBNO="row1.item.JOBNO"
                :PMC_JOBDATE="row1.item.JOBDate"
                :PMC_JOBTYPE="row1.item.JOBTYPE"
                :PMC_AgentType="''"
                :PMC_Client="row1.item.clientName"
                :PMC_Sline="row1.item.shippingLine"
              />
              <!-- <JobWisePaymentsDetails
                  v-if="row1.item.allModuleId"
                  :allModuleId="Number(row1.item.allModuleId)"
                  :JobNo="row1.item.JOBNO"
                  /> -->
            </template>
            <template slot="shippingLine" slot-scope="row2">
              <span> Client : {{ row2.item.clientName }}<br /></span>
              <span> Sline : {{ row2.item.shippingLine }}<br /></span>
            </template>
            <template slot="POR" slot-scope="row3">
              <span>No Of Cont. : {{ row3.item.multiConNo }}<br /></span>
              <span>Cont. Type : {{ row3.item.multipleContainerType }}<br /></span>
              <span>MBL : {{ row3.item.MBLNO }}<br /></span>
              <span>HBL : {{ row3.item.HBLNO }}<br /></span>
              <span>Booking No : {{ row3.item.BookingNo }}<br /></span>
              <span>Payment Status : {{ row3.item.oe_payment_status }}<br /></span>
              <span>Payment Date : {{ row3.item.oe_payment_date_first }}<br /></span>
              <span>PICK : {{ row3.item.PICK }}<br /></span>
              <span>STUFF : {{ row3.item.STUFF }}<br /></span>
              <span>HAND : {{ row3.item.HAND }}<br /></span>
              <span>POR : {{ row3.item.POR }}<br /></span>
              <div v-if="row3.item.JOBTYPE.split(',').includes('FF')">
                <span>POL : {{ row3.item.POL }}<br /></span>
                <span>POD : {{ row3.item.POD }}<br /></span>
                <span>FPOD : {{ row3.item.FPOD }}<br /></span>
              </div>
            </template>
            <template slot="allModuleId" slot-scope="row4">
              <span>ENQ No. : {{ row4.item.ENQNO }}<br /></span>
              <span
                >ENQ Type : {{ row4.item.ENQTYPE }}({{ row4.item.shipmentType }}
                {{ row4.item.transportType }})<br
              /></span>
              <span>ENQ Date : {{ row4.item.ENQDATE }}</span>
            </template>
            <template slot="isConsolidation" slot-scope="row5">
              <span>{{ row5.item.isConsolidation }}</span>
            </template>
          </b-table>
        </b-col>
        <b-col cols="12" class="text-center">
          <b-button class="mt-3" variant="outline-danger" @click="hideJobHistoryModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>

  <!-- Profit Loss Inv Expense Summary Section End -->
</template>

<script>
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import CommonService from "../../services/CommonService.js";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";

export default {
  props: {
    PMC_title: {
      type: String,
      default: "",
    },
    PMC_ClientID: {
      type: String,
      default: "",
    },
    PMC_ClientName: {
      type: String,
      default: "",
    },
    PMC_ClientEmail: {
      type: String,
      default: "",
    },
    PMC_ClientPhone: {
      type: String,
      default: "",
    },
    PMC_ClientSeries: {
      type: String,
      default: "",
    },
    PMC_Filter: {
      type: Object,
      default: {},
    },
  },
  beforeMount() {
    if (this.PMC_ClientID) {
      // this.getJobHistory();
    }
  },
  mounted() {},

  data() {
    return {
      Page_title: this.PMC_title,
      totalRows: 0,
      currentPage: 1,
      perPage: 300,
      pageOptions: [100, 200, 300],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      JobHistoryfields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "JOBNO",
          mainkey: "JOBNO",
          label: "Job details",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "shippingLine",
          mainkey: "shippingLine",
          label: "Sline",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "POR",
          mainkey: "POR",
          label: "Loc Details",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "allModuleId",
          mainkey: "allModuleId",
          label: "Enq Details",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "isConsolidation",
          mainkey: "isConsolidation",
          label: "EXP/INV AMT",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
      ],
      JobHistoryList: [],
      clientID: this.PMC_ClientID,
      isLoading: false,
      ExcelBtnName: "Export As Excel",
      docURL: URL_BASE_DOC,
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    InvExpSummary,
    ContainerSummary,
    JobWisePaymentsDetails,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getJobHistoryList("Normal");
      },
      deep: true,
    },
  },
  methods: {
    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getJobHistoryList("Excell");
    },
    getJobHistoryList(type) {
      this.PMC_Filter.clientIdFilter = this.clientID;
      this.JobHistoryList = [];
      let payload = {};
      if (this.clientID) {
        if (type == "Normal") {
          this.isLoading = true;
        }
        payload = {
          itemCode: "getJobHistoryList",
          clientID: this.PMC_ClientID,
          clientName: this.PMC_ClientName,
          type: type,
          Filter: this.PMC_Filter,
        };

        CommonService.getAllJobList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log();
            if (status == 200 && data) {
              if (type == "Excell") {
                if (data.getPendingClientJob.length > 0) {
                  this.JobHistoryList = data.getPendingClientJob;
                }
                this.ExcelBtnName = "Export As Excel";
                window.location.href =
                  `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
              } else {
                if (data.getPendingClientJob.length > 0) {
                  this.JobHistoryList = data.getPendingClientJob;
                }
              }
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on JobHistoryList Error: ", error);
          });
      }
    },

    getJobHistory(clientID) {
      this.JobHistoryList = [];
      this.$refs["JobHistory-modal"].show();
      this.getJobHistoryList("Normal");
      // this.isLoading = false;
    },
    hideJobHistoryModal() {
      this.JobHistoryList = [];
      this.$refs["JobHistory-modal"].hide();
      // this.isLoading = false;
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// moduleBasedClientJobs.vue?ac43a03a